const POWER_CONTROLS_LIST = (state, powerControlsList) => {
  state.powerControlsList = powerControlsList;
};

export default {
  POWER_CONTROLS_LIST,
};
